import { render, staticRenderFns } from "./PharmacyDetails.vue?vue&type=template&id=2c11f871&scoped=true"
import script from "./PharmacyDetails.vue?vue&type=script&lang=js"
export * from "./PharmacyDetails.vue?vue&type=script&lang=js"
import style0 from "./PharmacyDetails.vue?vue&type=style&index=0&id=2c11f871&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11f871",
  null
  
)

export default component.exports